export default __webpack_public_path__ + "static/media/app-collapse-active.083e350e.svg";